<template>
  <div>
    <world-nav/>
    <b-form-group id="buff" label="実績" class="form">
      <select-list
        :items="cardList"
        :fields="[
          { key:'icon', label:'' },
          { key:'name', label:'名前', filterType:'string', filterKey:'name' },
        ]"
        :perPage="10"
        tableKey='RID'
        :selectable="true"
        tableClass='action-list'
      >
        <template v-slot:cell(icon)="row">
          <img class="t-achievement" :src="row.item.icon | coalesceImage">
        </template>
        <template v-slot:cell(name)="row">
          <router-link :to="{ path:`/achievement/${row.item.index}` }">
            {{ row.item.name }}<font-awesome-icon icon="pen" class="icon fa-sx" />
          </router-link>
        </template>
      </select-list>
      <b-button size="sm"
        @click="addCard">
        <font-awesome-icon icon="plus-square" class="fa-1x p-0" />追加
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
// import store from '@/store'
import WorldNav from '@/components/WorldNav'
import SelectList from '@/components/SelectList'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
export default {
  filters: {
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  components: {
    WorldNav,
    SelectList
  },
  mixins: [mixinPlayer],
  computed: {
    cardList () {
      let list = []
      this.innerValue.card.forEach((v,i)=>{
        let e = _.find(v, { '@method':'info', args:{type:'achievement'} })
        if(e){
          list.push({
            index: i,
            name: e.args.name,
            icon: e.args.icon
          })
        }
      })
      return list
    }
  },
  props: {
    value: Object,
    postMessage: Object,
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  methods: {
    addCard () {
      let id = '@'+_.uniqueId()
      this.innerValue.card.push([
        { '@extend': 'card/achievement'},
        { '@method': 'init',
          'args': {
            key: id
          },
          'call': 'card/achievement.init'
        },
        { '@method': 'info',
          'args': {
            'icon':'./img/achievement/bronze.png',
            'name':'謎のスタンプ',
            'memo':'',
            'type':'achievement'
          },
          'call': 'card/achievement.info'
        },
        { '@method': 'entry-event', 
          'call': 'card/achievement.entry-event',
          'args':{
            command:{'@self':'class-path'},
            'type': 'status',
            'status': 'HP',
            'value': 5
          },
        },
        { '@method': 'get', 
          'hook':[],
          'args':{},
          'code':[],
        },
      ])
      this.$router.push({ path:`/achievement/${this.innerValue.card.length-1}` })
    }
  },
  created () {
    this.$emit('changePlayer', 'n-player')
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.ctl {
  width: 40px;
}
.t-card {
  position: relative;
  width: 100px;
  height: 100px;
}
</style>
